export enum BreadCrumbsEnum {
    Agenda=-1,
    Activities=0,
    CheckIn = 1,
    Sales = 2,
    Inventory = 3,
    ShareOfShelf = 4,
    CheckOut = 5,
    ESFCoverage = 6,
    Survey = 7,
    VisualTrade = 8,
    PriceShopping = 9,
    ProductCoverage = 10,
    POSLayout = 11,
    Feedback = 12,
    VisualInventory = 13,
    ClosingSales = 14,
    StockOut = 15,
    ServedClients =16,
}
